import React, { useEffect, useMemo } from 'react';
import UsersHeader from '../features/Users/components/UsersHeader';
import UsersTable from '../features/Users/components/UsersTable';
import { useUserStore } from '../features/Users/store/userStore';
import { User } from '../features/Users/types/user';
import UserProfileHeader from '../features/Users/components/userProfileHeader';
import UserProfileBody from '../features/Users/components/userProfileBody';
import { PuffLoader } from 'react-spinners';

const UsersContent: React.FC = () => {
  const [activeTab, setActiveTab] = React.useState('All');
  const [selectedService, setSelectedService] = React.useState('All');
  const [packages, setPackages] = React.useState([]);
  const [selectedPackage, setSelectedPackage] = React.useState('All');
  const [onExport, setOnExport] = React.useState(() => () => { });
  const { users, fetchUsers } = useUserStore();
  const [selectedUser, setSelectedUser] = React.useState<User | null>(null);
  const [searchTerm, setSearchTerm] = React.useState('');
  const [loading, setLoading] = React.useState(false);

      useEffect(() => {
          const loadUsers = async () => {
              if (users.length === 0) {
                  setLoading(true);
                  await fetchUsers();
                  setLoading(false);
              }
          };
  
          loadUsers();
      }, [users, fetchUsers]);

  const filteredUsers = useMemo(() => {
    return users.filter(user => {
      // Filter by service
      const serviceMatch =
        selectedService === 'All' ||
        user.service_name.toLowerCase() === selectedService.toLowerCase();
  
      // Filter by search
      const searchMatch =
        user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.phone?.toLowerCase().includes(searchTerm.toLowerCase());
  
      // (optional) filter by package, status, etc.
      // const packageMatch = selectedPackage === 'All' || user.package === selectedPackage;
  
      // Always require BOTH search + service + package to match
      return serviceMatch && searchMatch;
    });
  }, [selectedService, searchTerm, users]);
  
  if (loading) {
    return <div className='w-full flex flex-col items-center justify-center h-full'><PuffLoader color="#FFFFFF" /></div>;
}

  return (
    <div>
      {selectedUser ? (
        <div className='w-full flex flex-col items-start justify-start p-4'>
          <UserProfileHeader selectedUser={selectedUser} setSelectedUser={setSelectedUser} />
          <UserProfileBody user={selectedUser} />
        </div>
      ) : (
        <div className='w-full flex flex-col items-start justify-start p-4'>
          <UsersHeader
            usersCount={users.length}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            selectedService={selectedService}
            setSelectedService={setSelectedService}
            packages={packages}
            selectedPackage={selectedPackage}
            setSelectedPackage={setSelectedPackage}
            onExport={onExport}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
          />
          <UsersTable users={filteredUsers} setSelectedUser={setSelectedUser} />
        </div>
      )}
    </div>
  );
};

export default UsersContent;
